export const resetExtTreeModel = () => {
  const tree = window.Ext.getCmp("theDocSetList");
  tree.getSelectionModel().select(tree.getRootNode().firstChild);
  window.Ext.getCmp("sideBar").selectNodeById("sidebar-nav-folders");
};

export const getHostName = () => {
  let hostname = window.location.href;
  hostname = hostname.split("/");
  return `${hostname[0]}//${hostname[2]}`;
};

export const matrixAction = (docSetId, docId, action) => {
  window.PageObject.action = action;
  window.PageObject.folderId = docSetId;
  window.PageObject.documentId = docId;
  let extRef = `#DocSet_${docSetId}`;
  if (docId !== undefined) {
    extRef += `_DocRef_${docId}`;
  }
  window.PageObject.extRef = extRef;
  window.counter = {};
  window.counter[extRef] = 1;
  window.Application.common.drillInto(2, docSetId, docId);
  window.PageObject.received = false;
  let attempts = 0;
  const maxAttempts = 50;
  const t = setInterval(() => {
    const exists = document.querySelector(extRef) !== null;
    if (exists) {
      if (window.PageObject.received === true) {
        clearInterval(t);
        attempts = maxAttempts;
      }
      setTimeout(() => {
        postMessage(extRef, getHostName());
      }, 400);
    }
    attempts++;
    if (attempts === maxAttempts) {
      clearInterval(t);
    }
  }, 100);
};
